<template>
  <div>
    <van-tabs
      style="margin-bottom:80px"
      animated
      sticky
    >
      <van-tab title="单据信息">
        <van-form ref="infoForm">
          <van-cell-group inset>
            <van-field
              class="labelStyle"
              :model-value="'#'+ receipt.id"
              name="receiptId"
              readonly
              label="单据ID"
            />
            <van-field
              class="labelStyle"
              v-model="receipt.companyName"
              name="companyName"
              readonly
              label="公司名称"
            />
            <van-field
              class="labelStyle"
              v-model="receipt.customName"
              name="showroom"
              readonly
              label="客户名称"
            />
            <van-field
              class="labelStyle"
              v-model="receipt.shipName"
              name="showroom"
              readonly
              label="船舶名称"
            />
            <van-field
              class="labelStyle"
              v-model="receipt.voyagesName"
              name="showroom"
              readonly
              label="航次编号"
            />
            <van-field
              class="labelStyle"
              v-model="receipt.currencyName"
              name="showroom"
              readonly
              label="原币币种"
            />
            <van-field
              class="labelStyle"
              v-model="receipt.gatheredTotal"
              name="showroom"
              readonly
              :label="this.findReceiptCostDes(receipt.receiptType)"
            />
            <van-field
              class="labelStyle"
              v-model="receipt.receiptRate"
              name="showroom"
              readonly
              label="汇率"
            />
            <van-field
              class="labelStyle"
              v-model="receipt.applyAtDate"
              name="showroom"
              readonly
              :label="this.findReceiptData(receipt.receiptType)"
            />
            <van-field
              class="labelStyle"
              name="receiptType"
              readonly
              label="单据类型"
            ><template #input>{{this.findReceipt(receipt.receiptType)}}</template></van-field>
            <van-field
              class="labelStyle"
              name="showroom"
              readonly
              label="填写人员"
            >
              <template #input>
                <img
                  class="userHeader"
                  :src="parseHeader(receipt.submitUserIcon)"
                >
                <div class="userName">{{ receipt.submitUserNickName }}</div>
              </template>
            </van-field>
            <van-field
              class="labelStyle"
              v-model="receipt.submitAtDate"
              name="showroom"
              readonly
              label="录入时间"
            />
            <van-field
              class="labelStyle"
              name="showroom"
              readonly
              label="当前流转"
            >
              <template #input>
                <img
                  class="userHeader"
                  :src="parseHeader(receipt.flowUserIcon)"
                >
                <div class="userName">{{ receipt.flowUserNickName }}</div>
              </template>
            </van-field>
            <van-field
              class="labelStyle"
              v-model="receipt.verifyStatusDesc"
              name="showroom"
              readonly
              label="审核状态"
            />

            <van-field
              class="labelStyle"
              rows="1"
              type="textarea"
              v-model="receipt.remarks"
              name="showroom"
              readonly
              autosize
              label="备注记录"
            />
          </van-cell-group>
        </van-form>
        <div class="fileListPart">
          附件:
          <div
            style="padding-bottom: 10px;"
            v-for="(row, index) in fileList"
            :key="index"
          >
            <a
              style="display: block;overflow: hidden;"
              :href="row.url"
            >{{decodeURIComponent( row.url ) }}</a>
          </div>
        </div>
      </van-tab>
      <van-tab title="资金类别">
        <div>
          <div
            :key="index"
            v-for="(value, index) in receipt.tableToc.cells"
          >
            <van-form>
              <van-cell-group inset>
                <van-field
                  class="labelStyle"
                  v-model="value.fundCategory"
                  name="showroom"
                  readonly
                  label="资金类别"
                />
                <van-field
                  class="labelStyle"
                  v-model="value.content"
                  name="showroom"
                  readonly
                  label="内容"
                />
                <van-field
                  class="labelStyle"
                  name="showroom"
                  readonly
                  label="收款金额"
                >
                  <template #input>
                    {{ parseFloat(value.orgGathered).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                  </template>
                </van-field>
                <van-field
                  class="labelStyle"
                  name="showroom"
                  readonly
                  label="付款金额"
                >
                  <template #input>
                    {{ parseFloat(value.orgPay).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                  </template>
                </van-field>
                <van-field
                  class="labelStyle"
                  name="showroom"
                  readonly
                  label="记账借方"
                >
                  <template #input>
                    {{ parseFloat(value.orgGathered / receipt.receiptRate).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                  </template>
                </van-field>
                <van-field
                  class="labelStyle"
                  v-model="value.usdPay"
                  name="showroom"
                  readonly
                  label="记账贷方"
                >
                  <template #input>
                    {{ parseFloat(value.orgPay / receipt.receiptRate).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                  </template>
                </van-field>
              </van-cell-group>
            </van-form>
            <van-divider :style="{ color: '#333333', borderColor: '#333333', padding: '0 30px' }" />
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <!-- 审核通过界面 -->
    <van-popup
      v-model:show="showPass"
      round
      closeable
      :close-on-click-overlay=false
      position="bottom"
    >
      <div class="pass-title">审核通过</div>
      <div class="tip-title">选择流转人员</div>
      <van-divider style="margin-bottom:0" />
      <van-radio-group v-model="checked">
        <van-cell-group inset>
          <van-cell
            clickable
            @click="selectUser(item.value, item.icon, item.label)"
            v-for="(item,index) in userOptionsList"
            :key="index"
          >
            <template #right-icon>
              <div style="flex:1;display: flex;">
                <img
                  class="userHeader"
                  :src="parseHeader(item.icon)"
                >

                <div
                  class="userName"
                  style="display: inline;padding-left: 5px;"
                >{{ item.label }}</div>
              </div>
              <van-radio :name="item.value"></van-radio>
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <van-cell>
        <van-field
          class="labelStyle"
          v-model="passRemarks"
          name="showroom"
          type="textarea"
          label="备注"
          rows="3"
          size="small"
          placeholder="填写备注"
        />
      </van-cell>
      <div style="margin: 0px;width:100%;margin-top: 20px;margin-bottom: 20px;">
        <van-button
          class="normalBtn"
          style="width:43%;margin-right:6%"
          @click="onCancelPassClick"
        >取消</van-button>
        <van-button
          class="normalBtn"
          type="danger"
          style="width:43%"
          @click="onSurePassClick"
        >确认通过</van-button>
      </div>
    </van-popup>
    <!-- 审核驳回界面 -->
    <van-popup
      v-model:show="showReject"
      round
      closeable
      :close-on-click-overlay=false
      position="bottom"
    >
      <div class="reject-title">审核驳回</div>
      <div class="tip-title">驳回到初始填写人</div>
      <van-divider style="margin-bottom:0" />
      <van-radio-group v-model="this.receipt.submitUserId">
        <van-cell-group inset>
          <van-cell>
            <template #right-icon>
              <div style="flex:1;display: flex;">
                <img
                  class="userHeader"
                  :src="parseHeader(this.receipt.submitUserIcon)"
                >
                <div
                  class="userName"
                  style="display: inline;padding-left: 5px;"
                >{{ this.receipt.submitUserNickName }}</div>
              </div>
              <van-radio :name="this.receipt.submitUserId"></van-radio>
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <van-cell>
        <van-field
          class="labelStyle"
          v-model="rejectRemarks"
          name="showroom"
          type="textarea"
          label="备注"
          rows="3"
          size="small"
          placeholder="填写备注"
        />
      </van-cell>
      <div style="margin: 0px;width:100%;margin-top: 20px;margin-bottom: 20px;">
        <van-button
          class="normalBtn"
          style="width:43%;margin-right:6%"
          @click="onCancelRejectClick"
        >取消</van-button>
        <van-button
          class="normalBtn"
          type="danger"
          style="width:43%"
          @click="onSureRefuseClick"
        >确认驳回</van-button>
      </div>
    </van-popup>
    <div
      style="margin: 0px;width:100%;margin-top: 10px;position: fixed; bottom: 10px;"
      v-show="runningMine"
    >
      <van-button
        class="normalBtn"
        type="success"
        style="width:43%;margin-right:6%"
        @click="onSubmitClick"
      >审核通过</van-button>
      <van-button
        class="normalBtn"
        type="danger"
        style="width:43%"
        @click="onRejectClick"
      >审核驳回</van-button>
    </div>
    <!-- 流转中 -->
    <div
      style="margin: 0px;width:100%;margin-top: 10px;position: fixed; bottom: 10px;"
      v-show="!runningMine"
    >
      <van-button
        class="normalBtn"
        type="default"
        style="width:100%"
      >流转中</van-button>
    </div>
  </div>
  <van-overlay
    :show="loading"
    z-index='2002'
  >
    <van-loading
      class="wrapper"
      color="#1989fa"
    >
    </van-loading>
  </van-overlay>
</template>

<script>
import EnumDic from '@/utils/EnumDic';
import { FReceiptPass, FReceiptReceiver, FReceiptRefuse } from '@/utils/methodCenter';
import { showToast } from 'vant';
import { watch } from 'vue';

export default {
  name: "ReceiptDetail",
  props: {
    token: {
      type: String,
      default: '123'
    },
    receiptValue: {
      type: Object,
      default: () => { }
    },
    myUserId: {
      type: String,
      default: ''
    },
    passForceSuccess: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    receiptType: {
      get: () => {
        if (this.receipt.receiptType == 1) {
          return '收款单'
        } else if (this.receipt.receiptType == 2) {
          return '付款单'
        } else {
          return '报销单'
        }
      },
      set: () => {

      }
    }
  },
  setup (props) {
    watch(() => props.receiptValue, (newValue, oldValue) => {
      console.log('11newvalue:', newValue, oldValue)
      // this.receipt = newValue
    })
  },
  data () {
    return {
      receipt: {},
      fileList: [],
      showPass: false,
      showReject: false,
      checked: -1,
      passRemarks: '', // 审核通过备注
      rejectRemarks: '', // 审核拒绝备注
      passIcon: '',
      passNickName: '',
      rejectNickName: '',
      rejectIcon: '',
      loading: false,
      runningMine: true, // 需要我审核
      userOptionsList: []
    }
  },
  mounted () {
  },
  watch: {
    receiptValue: {
      handler (value, oldData) {
        console.log('receiptValue123:', value, 'old:', oldData)
        this.receipt = value
        this.findOptions(this.receipt.id)
        if (this.receipt.flowUserId === Number(this.myUserId) && this.parseStatus(this.receipt.verifyStatus)) {
          this.runningMine = true
        } else {
          this.runningMine = false
        }
        // if(Number(this.myUserId) == 1){
        //   this.runningMine = true
        // }

        this.fileList = []
        if (this.receipt.attachFiles) {
          var lists = this.receipt.attachFiles.split(',')
          for (var item in lists) {
            this.fileList.push({ url: lists[item] })
          }
        }
      },
      deep: true, // 深度监听
      immediate: true
    }
  },
  methods: {
    findReceiptCostDes (receiptType) {
      console.log('findReceiptCostDes:', receiptType)
      if (receiptType == 1) {
        return '收款金额'
      } else if (receiptType == 2) {
        return '付款金额'
      } else {
        return '付款金额'
      }
    },
    findReceiptData (receiptType) {
      console.log('findReceiptData:', receiptType)
      if (receiptType == 1) {
        return '收款日期'
      } else if (receiptType == 2) {
        return '付款日期'
      } else {
        return '付款日期'
      }
    },
    findReceipt (receiptType) {
      console.log('findReceipt:', receiptType)
      if (receiptType == 1) {
        return '收款单'
      } else if (receiptType == 2) {
        return '付款单'
      } else {
        return '报销单'
      }
    },
    findOptions (id) {
      this.searchOptionByType(id, FReceiptReceiver, (data) => {
        this.userOptionsList = data
      })
    },
    searchOptionByType (id, callFun, callback) {
      var parameter = {}
      parameter.receiptObjId = id
      parameter.receiptType = this.receipt.receiptType
      parameter.pageSize = -1
      parameter.curIdx = 0
      console.log('send order pass loadData.parameter', parameter, this.queryParam)
      if (callFun) {
        callFun(Object.assign(parameter, this.queryParam)).then(res => {
          var resultData = []
          var item
          var result = res.data
          if (result.data) {
            for (var companyItem in result.data) {
              item = result.data[companyItem]
              resultData.push({ value: item.userId, label: item.flowUserNickName, icon: item.flowUserIcon })
            }
          }
          callback(resultData)
        })
      }
    },
    // 选人
    selectUser (value, icon, nickName) {
      this.checked = value
      this.passIcon = icon;
      this.passNickName = nickName
    },
    // 确认通过
    onSurePassClick () {
      console.log('onSurePassClick:', this.passIcon, this.passNickName)
      if (this.passNickName.trim() == '') {
        showToast('请选择流转人员');
        return
      }
      this.loading = true
      this.showPass = false
      const token = this.token
      var values = {
        token: token,
        passStatusId: this.receipt.verifyStatus,
        receiptObjId: this.receipt.id,
        receiptType: this.receipt.receiptType,
        dstUserIcon: this.passIcon,
        dstUserNickName: this.passNickName,
        remarks: this.passRemarks
      }
      // return;
      FReceiptPass(values).then((res) => {
        this.loading = false
        console.log('FReceiptPass res:', res)
        var result = res.data
        // 审核通过的时候判断是否有金额相似的
        if (result.errCode === 2013) {
          this.tableRepeatData = res
          this.$emit('receiptMoreLike', values, result)
        } else {
          this.runningMine = false
          console.log('success')
        }
      })
    },
    onCancelPassClick () {
      this.showPass = false
    },
    onSubmitClick () {
      this.showPass = true
    },
    // 显示驳回页面
    onRejectClick () {
      this.showReject = true
    },
    // 取消驳回界面
    onCancelRejectClick () {
      this.showReject = false
    },
    // 确认驳回
    onSureRefuseClick () {
      if (this.rejectRemarks.trim() == '') {
        showToast('请填写备注原因')
        return
      }
      var sendData = {
        token: this.token,
        passStatusId: this.receipt.verifyStatus,
        receiptObjId: this.receipt.id,
        receiptType: this.receipt.receiptType,
        remarks: this.rejectRemarks
      }
      this.showReject = false
      this.loading = true
      FReceiptRefuse(sendData).then((res) => {
        this.loading = false
        this.runningMine = false
        console.log(res)
      })
    },
    parseStatus: function (statusType) {
      var canOperateMine = false
      switch (statusType) {
        case EnumDic.OcrmReceiptVerifyTypeEnum.Init:
        case EnumDic.OcrmReceiptVerifyTypeEnum.Refuse:
        case EnumDic.OcrmReceiptVerifyTypeEnum.Finish:
        case EnumDic.OcrmReceiptVerifyTypeEnum.UNKNOWN:
        case EnumDic.OcrmReceiptVerifyTypeEnum.CashierFinish:
          canOperateMine = false
          break
        default:
          canOperateMine = true
          break
      }

      return canOperateMine;
    },
    parseHeader: function (url) {
      if (url === '') {
        return require('@/assets/header/image.png')
      } else if (url === 'http://www.admin.com') {
        return require('@/assets/header/image.png')
      } else {
        return url
      }
    }
  }
}
</script>

<style>
.userHeader {
  width: 24px;
  height: 24px;
  border-radius: 24px;
}
.userName {
  line-height: 24px;
}

.fileListPart {
  text-align: left;
  margin-left: 30px;
  margin-right: 30px;
}

.pass-title {
  color: green;
  font-size: 18px;
  padding-bottom: 15px;
  padding-top: 15px;
}
.reject-title {
  color: red;
  font-size: 18px;
  padding-bottom: 15px;
  padding-top: 15px;
}

.tip-title {
  font-size: 15px;
  padding-top: 15px;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>